module.exports = __webpack_public_path__ + "assets/img/title-a8dd5739.png";